<template>
  <div class="table-responsive">
    <table class="table border-bottom table-hover text-left" id="dataTable" width="100%" cellspacing="0">
      <thead>
        <tr>
          <th>Subject</th>
          <!--          <th width="25%">Body</th>-->
          <th>Type</th>
          <th>Sent</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr  v-if="isLoader" id="table_row" >
          <td colspan="16">
            <b-skeleton-wrapper >
                <b-skeleton height="40px" ></b-skeleton>   
                <b-skeleton height="40px"></b-skeleton>  
                <b-skeleton height="40px"></b-skeleton>                                     
            </b-skeleton-wrapper> 
          </td>
        </tr>
        <tr v-show="!isLoader" v-for="notification in notifications" :demo="notification" :key="notification.id">
          <!-- company -->
          <b-tooltip  v-if="notification.subject.length >= 40" :target="'notification'+notification.id" placement="bottom" style=""> 
            {{ notification.subject }}
              </b-tooltip>
          <td v-if="notification.subject.length > 40"  :id="'notification'+notification.id" v-html="notification.subject.substring(0, 40) + '...'" ></td>
          <td v-else>{{ notification.subject }}</td>

          <!-- name -->
          <!--          <td align="left" v-html="notification.body"></td>-->

          <!-- phone -->
          <td v-if="notification.notification_type == 0">Email</td>
          <td v-else-if="notification.notification_type == 1">Notification</td>
          <td v-else-if="notification.notification_type == 2">Email & Notification</td>
            <!-- {{
            notification.type == 2 && notification.read_by_org != 0
            ? "Notification"
            : "Post Mail"
            }} -->

          <!-- email -->
          <td>{{ notification.created_at | formatDate }}</td>

          <!-- controls [update, delete] -->
          <!-- <td >
            <div v-if="notification.notification_type == 1 || notification.notification_type == 2" class="btn-group btn-group-sm">
              <router-link :to="'/notifications/update-notification/' + notification.id" class="btn btn-info px-3">Edit
              </router-link>
            </div>
          </td> -->
          <td class="text-center">
          
            <a  class="btn dropdown-toggle" data-toggle="dropdown" href="#"  v-show="notification.notification_type == 1 || notification.notification_type == 2">
              <span class="fas fa-ellipsis-v"></span>
            </a>
            <ul class="dropdown-menu action-list">
              <li  > <router-link class="dropdown-item" :to="'/notifications/update-notification/' + notification.id">Edit</router-link> </li>
              <!-- <li  v-if="lead.onboardlead.length > 0 && lead.onboardlead[0].on_hold == 0"> <a class="dropdown-item" @click="updateStatus" :data-id="lead.id" :data-status="5">On-hold</a> </li>
              <li  v-if="lead.onboardlead.length > 0 && lead.onboardlead[0].on_hold == 1 && lead.onboardlead[0].lead_status != 4"> <a class="dropdown-item" @click="updateStatus" :data-id="lead.id" :data-status="6">Resume</a> </li> -->
            </ul>
        </td>
        </tr>
      </tbody>
    </table>

    <h5 style="text-align: center" v-if="notifications.length < 1 && !isLoader">
      No data found.
    </h5>
    
    <div v-if="!isLoader">
      <paginate v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
        :first-button-text="''" :last-button-text="''" :first-last-button="true"
        :container-class="'pagination pagination-sm float-right mt-3 mr-4 mb-0'" :page-class="'page-item'"
        :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
        :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
        <span class=" float-right mt-3 mr-4 mb-0 display-rows" style="color:#48a6a6;">Display Rows: <b>{{totalRows}}</b></span>
        <span class=" float-right mt-3 mr-4 mb-0 display-rows" style="color:#48a6a6;">Total Notifications: <b>{{totalRecords}}</b></span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
  import $ from "jquery";
  Vue.filter("formatDate", function (value) {
    if (value != "0000-00-00 00:00:00" && value != null) {
      return moment(String(value)).format("MMM DD, Y LT");
    }
  });
  export default {
    props: ["notification", "notifications", "totalPages", "page", "setSkeletonLoader","totalRows"],
    data: function () {
      return {
        isLoader: true,
      };
    },
    computed: {
      currentPage: {
        get: function () {
          this.selectedPage = this.$store.getters["users/currentPage"];
          return this.selectedPage;
        },
        set: function () { },
      },
      showskLoader: {
        get:function(){
          return this.setSkeletonLoader
        },
        set: function (val) {
          this.isLoader = val;
          return val;
         },
      },
      totalRecords: function () {
        return this.$store.getters["users/totalRecords"];
      },
    },
    watch:{
      showskLoader: function (val) {
        this.isLoader = val;
        return val;
      },

     } ,
    mounted: function () {
      this.showskLoader = this.setSkeletonLoader;
      this.notifications.notification_type
      setTimeout(function () {
        $("img[src*=data\\:image]").css("max-width", "100%");
      }, 1000);
    },

    methods: {
      setPage(page) {
        this.$emit("setPage", page);
      },
    },
  };
</script>
<style scoped>
 ul.dropdown-menu.action-list{
    transform:  translate3d(1433px, 398px, 0px) ;
    width: 11% !important;
  }
  ul.dropdown-menu.action-list li{
    text-align: left ;
  }
  table tr td .dropdown-menu {
    min-width: 4px !important;
  }
  table tbody tr td:first-child{
    color: #48a6a6;
  }
</style>